import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

export class Sort {
  title: string;
  property: string;
}

export class Direction {
  title: string;
  direction: 'ASC' | 'DESC';
}

export class SearchParams {
  id: number;
  startDate: number;
  endDate: number;
  keyword: string;
  author: string;
  sort: Sort;
  direction: Direction;
}

@Component({
  selector: 'app-idea-search-panel',
  templateUrl: './idea-search-panel.component.html',
  styleUrls: ['./idea-search-panel.component.scss']
})
export class IdeaSearchPanelComponent implements OnInit, OnDestroy {

  /**
   *
   */
  @Output() onSearch: EventEmitter<SearchParams> = new EventEmitter();

  /**
   * Search form
   */
  searchForm: FormGroup;

  /**
   * All possible sortings
   */
  sorts: Sort[] = [
    {
      title: 'სათაური',
      property: 'title'
    },
    {
      title: 'ხმების რაოდენობა',
      property: 'signerQuantity'
    }
  ];

  /**
   * Directions
   */
  directions: { [key: string]: Direction[]; } = {
    title: [
      {
        title: 'ა(A) > ჰ(Z)',
        direction: 'ASC'
      },
      {
        title: 'ჰ(Z) > ა(A)',
        direction: 'DESC'
      }
    ],
    signerQuantity: [
      {
        title: 'კლებადი',
        direction: 'DESC'
      },
      {
        title: 'ზრდადი',
        direction: 'ASC'
      }
    ]
  };

  /**
   * Subscriptions
   */
  private _subs: Set<Subscription> = new Set();

  /**
   * Constructor
   *
   * @param _fb
   */
  constructor(private _fb: FormBuilder) {
    this.searchForm = _fb.group({
      id: [''],
      startDate: [null],
      endDate: [null],
      keyword: [''],
      author: [''],
      sort: [null],
      direction: [null]
    });
  }

  /**
   * Init
   */
  ngOnInit() {
    this._subs.add(
      this.searchForm.controls['sort'].valueChanges.subscribe((value: Sort) => {
        this.searchForm.controls['direction'].setValue(this.directions[value.property][0]);
      })
    );

    this._subs.add(
      this.searchForm.valueChanges.subscribe((value) => {
        const searchParams: SearchParams = Object.assign({}, value);

        if (searchParams.startDate) {
          searchParams.startDate = new Date(value.startDate).getTime();
        }

        if (searchParams.endDate) {
          searchParams.endDate = IdeaSearchPanelComponent.addDays(new Date(value.endDate), 1).getTime();
        }

        this.onSearch.emit(searchParams);
      })
    );
  }

  /**
   * Destroy
   */
  ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Adds days to given date
   *
   * @param date
   * @param days
   */
  static addDays(date: Date, days: number) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  /**
   * Clears form control value
   *
   * @param formControlName
   */
  resetInput(formControlName: string) {
    if (this.searchForm.contains(formControlName)) {
      this.searchForm.controls[formControlName].reset();
    }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/idea-search-panel/idea-search-panel.component.ts